import { fetchMainApi } from '@/api/index'

// Payment profiles: the account's saved credit cards / bank accounts (Authorize.net CIM).
// Scoped to the logged-in user's account on the backend.

export const getPaymentProfiles = () => fetchMainApi('GET', '/payment-profiles')

export const addPaymentProfile = (data) =>
  fetchMainApi('POST', '/payment-profiles', {
    body: JSON.stringify(data)
  })

// Leave card_number / account_number out of `data` to keep the saved instrument; sending them replaces it
export const updatePaymentProfile = (id, data) =>
  fetchMainApi('PUT', `/payment-profiles/${id}`, {
    body: JSON.stringify(data)
  })

export const deletePaymentProfile = (id) => fetchMainApi('DELETE', `/payment-profiles/${id}`)

// direction: 'pay_in' (you pay for loads) | 'pay_out' (you receive payouts)
export const setDefaultPaymentProfile = (id, direction) =>
  fetchMainApi('POST', `/payment-profiles/${id}/set-default`, {
    body: JSON.stringify({ direction })
  })
